import React, { Component } from "react";
import {
  Button,
  Container,
  Row,
  Col,
  Card,
  Badge,
  Form,
  Alert,
  Modal
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Companyhasemployees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      employeeStatusList: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      loading: false,
      
      // Company member counts
      memberCounts: {
        total_employees: 0,
        total_adults: 0,
        total_children: 0,
        total_parents: 0,
        total_members: 0
      },

      // Add member modal
      showAddMemberModal: false,
      addMemberForm: {
        employeeid: "",
        memberfullname: "",
        gender: "",
        dob: "",
        relationwithemployee: "Self",
        suminsured: "",
        pincode: "",
        mobilenumber: "",
        emailId: ""
      },

      // Employee management
      editingEmployee: null,
      showEmployeeModal: false,

      tableClms: [
        {
          name: "Employee ID",
          selector: (row) => row.companyemployeeid,
          sortable: true,
          width: "120px",
          cell: (row) => <span>{row.companyemployeeid}</span>,
        },
        {
          name: "Employee Name",
          selector: (row) => row.memberfullname || `${row.fName || ''} ${row.lName || ''}`.trim(),
          sortable: true,
          width: "180px",
          cell: (row) => (
            <span>
              {row.memberfullname || `${row.fName || ''} ${row.lName || ''}`.trim() || 'N/A'}
            </span>
          ),
        },
        {
          name: "Status",
          selector: (row) => row.employeeStatus,
          sortable: true,
          width: "120px",
          cell: (row) => (
            <Badge bg={row.is_currently_active ? 'success' : 'secondary'}>
              {row.employeeStatus}
            </Badge>
          ),
        },
        {
          name: "Adults",
          selector: (row) => row.noofadults,
          sortable: true,
          width: "80px",
          cell: (row) => <span>{row.noofadults || 0}</span>,
        },
        {
          name: "Children",
          selector: (row) => row.noofchildren,
          sortable: true,
          width: "80px",
          cell: (row) => <span>{row.noofchildren || 0}</span>,
        },
        {
          name: "Parents",
          selector: (row) => row.noofparents,
          sortable: true,
          width: "80px",
          cell: (row) => <span>{row.noofparents || 0}</span>,
        },
        {
          name: "Total Members",
          selector: (row) => row.totalmembers,
          sortable: true,
          width: "120px",
          cell: (row) => <span>{row.totalmembers || 0}</span>,
        },
        {
          name: "Relieving Date",
          selector: (row) => row.employeerelievingdate,
          sortable: true,
          width: "130px",
          cell: (row) => (
            <span>{row.employeerelievingdate || 'N/A'}</span>
          ),
        },
        {
          name: "Actions",
          sortable: false,
          width: "280px",
          cell: (row) => (
            <div>
              <Button
                variant="primary"
                size="sm"
                onClick={() => this.handleEditEmployee(row)}
                className="me-1"
                title="Edit Employee"
              >
                <i className="bi bi-pen"></i>
              </Button>
              <Button
                variant="info"
                size="sm"
                onClick={() => this.handleManageFamily(row)}
                className="me-1"
                title="Manage Family Members"
              >
                <i className="bi bi-people"></i>
              </Button>
              <Button
                variant="success"
                size="sm"
                onClick={() => this.handleManagePED(row)}
                className="me-1"
                title="Manage PED"
              >
                <i className="bi bi-heart-pulse"></i>
              </Button>
            </div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.loadCompanyMemberCounts();
    this.loadCompanyEmployees();
    this.loadEmployeeStatusList();
  }

  showToast = (message, type) => {
    toast(message, { type: type });
  };

  // Load company member counts
  loadCompanyMemberCounts = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Companyhasemployees/get_company_member_counts", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ memberCounts: data.counts });
        } else {
          this.showToast(data.message, "error");
        }
      })
      .catch((error) => {
        this.showToast("Error loading member counts", "error");
      });
  };

  // Load company employees
  loadCompanyEmployees = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Companyhasemployees/get_company_employees", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.employees });
        } else {
          this.showToast(data.message, "error");
        }
      })
      .catch((error) => {
        this.showToast("Error loading employee data", "error");
      });
  };

  // Sync company member counts
  syncCompanyCounts = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    this.setState({ loading: true });

    fetch(configData.api_url + "C_Companyhasemployees/sync_company_counts", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, "success");
          // Reload member counts and employee data after sync
          this.loadCompanyMemberCounts();
          this.loadCompanyEmployees();
        } else {
          this.showToast(data.message, "error");
        }
      })
      .catch((error) => {
        this.showToast("Error synchronizing counts", "error");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  // Load employee status master list
  loadEmployeeStatusList = () => {
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + "C_Employeestatusmaster/index", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ employeeStatusList: data.list });
        }
      })
      .catch((error) => {
        console.log("Error loading employee status list:", error);
      });
  };

  // Handle edit employee
  handleEditEmployee = (employee) => {
    this.setState({
      editingEmployee: { ...employee },
      showEmployeeModal: true
    });
  };

  // Handle manage family navigation
  handleManageFamily = (employee) => {
    const companyId = employee.companyid;
    const employeeId = employee.companyemployeeid;
    
    if (!companyId || !employeeId) {
      this.showToast("Company ID or Employee ID is missing", "error");
      return;
    }
    
    // Navigate to EmployeeFamilyManagement with URL parameters
    const familyUrl = `/employeefamilymanagement?companyid=${companyId}&employeeid=${employeeId}`;
    
    // Show confirmation message
    const employeeName = employee.memberfullname || `${employee.fName || ''} ${employee.lName || ''}`.trim() || `Employee ID: ${employeeId}`;
    this.showToast(`Navigating to Family Management for Employee: ${employeeName}`, "info");
    
    // Navigate after a short delay to let the user see the message
    setTimeout(() => {
      window.location.href = familyUrl;
    }, 1000);
  };

  // Handle manage PED navigation
  handleManagePED = (employee) => {
    const companyId = employee.companyid;
    const employeeId = employee.companyemployeeid;
    
    if (!companyId || !employeeId) {
      this.showToast("Company ID or Employee ID is missing", "error");
      return;
    }
    
    // Navigate to PED_Magma with URL parameters for auto-loading
    const pedUrl = `/pedmagma?companyid=${companyId}&employeeid=${employeeId}`;
    
    // Show confirmation message
    const employeeName = employee.memberfullname || `${employee.fName || ''} ${employee.lName || ''}`.trim() || `Employee ID: ${employeeId}`;
    this.showToast(`Navigating to PED Management for Employee: ${employeeName}`, "info");
    
    // Navigate after a short delay to let the user see the message
    setTimeout(() => {
      window.location.href = pedUrl;
    }, 1000);
  };

  // Handle employee form change
  handleEmployeeFormChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      editingEmployee: {
        ...prevState.editingEmployee,
        [name]: value
      }
    }));
  };

  // Save employee changes
  saveEmployeeChanges = () => {
    if (!this.state.editingEmployee) return;

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyhasemployees_Id", this.state.editingEmployee.companyhasemployees_Id);
    formData.append("employeeStatus", this.state.editingEmployee.employeeStatus);
    
    if (this.state.editingEmployee.employeerelievingdate) {
      formData.append("employeerelievingdate", this.state.editingEmployee.employeerelievingdate);
    }

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Companyhasemployees/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast("Employee updated successfully", "success");
          this.setState({ showEmployeeModal: false, editingEmployee: null });
          this.loadCompanyEmployees();
          this.loadCompanyMemberCounts();
        } else {
          this.showToast(data.message, "error");
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        this.showToast("Error updating employee", "error");
      
        this.setState({ loading: false });});
  };

  // Handle add member form change
  handleAddMemberFormChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      addMemberForm: {
        ...prevState.addMemberForm,
        [name]: value
      }
    }));
  };

  // Add new member
  addNewMember = () => {
    const { addMemberForm } = this.state;

    // Validate required fields
    if (!addMemberForm.employeeid || !addMemberForm.memberfullname || 
        !addMemberForm.gender || !addMemberForm.dob) {
      this.showToast("Please fill all required fields", "error");
      return;
    }

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    
    Object.keys(addMemberForm).forEach(key => {
      if (addMemberForm[key]) {
        formData.append(key, addMemberForm[key]);
      }
    });

    fetch(configData.api_url + "C_Companyhasemployees/add_new_member", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, "success");
          this.setState({
            showAddMemberModal: false,
            addMemberForm: {
              employeeid: "",
              memberfullname: "",
              gender: "",
              dob: "",
              relationwithemployee: "Self",
              suminsured: "",
              pincode: "",
              mobilenumber: "",
              emailId: ""
            }
          });
          this.loadCompanyEmployees();
          this.loadCompanyMemberCounts();
        } else {
          this.showToast(data.message, "error");
        }
      })
      .catch((error) => {
        this.showToast("Error adding new member", "error");
      });
  };

  render() {
    const { memberCounts, data, employeeStatusList, editingEmployee, addMemberForm, loading } = this.state;

    return (
      <Container fluid className="mt-3">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <h3 className="logoskybluecolor mb-4">Company Employee Management</h3>
        
        {/* Member Counts Dashboard */}
        <Row className="mb-4">
          <Col lg={12}>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Company Member Statistics (Active Employees Only)</h5>
                <Button 
                  variant="outline-secondary" 
                  size="sm"
                  onClick={this.syncCompanyCounts}
                  disabled={loading}
                >
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  {loading ? 'Syncing...' : 'Sync Counts'}
                </Button>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col lg={2} md={4} sm={6} className="mb-3">
                    <Card className="text-center bg-primary text-white">
                      <Card.Body>
                        <h4>{memberCounts.total_employees}</h4>
                        <p className="mb-0">Total Employees</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={2} md={4} sm={6} className="mb-3">
                    <Card className="text-center bg-success text-white">
                      <Card.Body>
                        <h4>{memberCounts.total_adults}</h4>
                        <p className="mb-0">Adults</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={2} md={4} sm={6} className="mb-3">
                    <Card className="text-center bg-info text-white">
                      <Card.Body>
                        <h4>{memberCounts.total_children}</h4>
                        <p className="mb-0">Children</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={2} md={4} sm={6} className="mb-3">
                    <Card className="text-center bg-warning text-white">
                      <Card.Body>
                        <h4>{memberCounts.total_parents}</h4>
                        <p className="mb-0">Parents</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={2} md={4} sm={6} className="mb-3">
                    <Card className="text-center bg-dark text-white">
                      <Card.Body>
                        <h4>{memberCounts.total_members}</h4>
                        <p className="mb-0">Total Members</p>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col lg={2} md={4} sm={6} className="mb-3">
                    <Button 
                      variant="outline-primary" 
                      size="lg"
                      onClick={() => this.setState({ showAddMemberModal: true })}
                      className="h-100 w-100"
                    >
                      <i className="bi bi-plus-circle me-2"></i>
                      Add New Member
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Employee Data Table */}
        <Row>
          <Col lg={12}>
            <Card>
              <Card.Header>
                <h5>Employee Management</h5>
                <small className="text-muted">
                  Manage employee status and relieving dates. Counts are automatically updated based on active employees only.
                </small>
              </Card.Header>
              <Card.Body>
                <DataTable
                  data={data}
                  columns={this.state.tableClms}
                  pagination
                  keyField="companyhasemployees_Id"
                  className="table table-striped table-bordered"
                  noDataComponent="No employees found"
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Edit Employee Modal */}
        <Modal show={this.state.showEmployeeModal} onHide={() => this.setState({ showEmployeeModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Employee Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editingEmployee && (
              <Form>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Employee ID</Form.Label>
                      <Form.Control
                        type="text"
                        value={editingEmployee.companyemployeeid || ''}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Employee Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={editingEmployee.memberfullname || `${editingEmployee.fName || ''} ${editingEmployee.lName || ''}`.trim() || 'N/A'}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Employee Status *</Form.Label>
                      <Form.Select
                        name="employeeStatus"
                        value={editingEmployee.employeeStatus || ''}
                        onChange={this.handleEmployeeFormChange}
                        required
                      >
                        <option value="">Select Status</option>
                        {employeeStatusList.map((status) => (
                          <option key={status.employeestatusmaster_Id} value={status.EmployeeStatus}>
                            {status.EmployeeStatus}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Relieving Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="employeerelievingdate"
                        value={editingEmployee.employeerelievingdate || ''}
                        onChange={this.handleEmployeeFormChange}
                      />
                      <Form.Text className="text-muted">
                        Leave empty for active employees
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showEmployeeModal: false })}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.saveEmployeeChanges}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add New Member Modal */}
        <Modal 
          show={this.state.showAddMemberModal} 
          onHide={() => this.setState({ showAddMemberModal: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Add New Member</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="info">
              <strong>Note:</strong> Freeze date will be automatically set to current date + 5 days for new members.
            </Alert>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Employee ID *</Form.Label>
                    <Form.Control
                      type="text"
                      name="employeeid"
                      value={addMemberForm.employeeid}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Employee ID"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Member Full Name *</Form.Label>
                    <Form.Control
                      type="text"
                      name="memberfullname"
                      value={addMemberForm.memberfullname}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Full Name"
                      required
                    />
                    <Form.Text className="text-muted">
                      Will auto-split into first and last name
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Gender *</Form.Label>
                    <Form.Select
                      name="gender"
                      value={addMemberForm.gender}
                      onChange={this.handleAddMemberFormChange}
                      required
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Date of Birth *</Form.Label>
                    <Form.Control
                      type="date"
                      name="dob"
                      value={addMemberForm.dob}
                      onChange={this.handleAddMemberFormChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Relation with Employee</Form.Label>
                    <Form.Select
                      name="relationwithemployee"
                      value={addMemberForm.relationwithemployee}
                      onChange={this.handleAddMemberFormChange}
                    >
                      <option value="Self">Self</option>
                      <option value="Spouse">Spouse</option>
                      <option value="Son">Son</option>
                      <option value="Daughter">Daughter</option>
                      <option value="Mother">Mother</option>
                      <option value="Father">Father</option>
                      <option value="Motherinlaw">Mother-in-law</option>
                      <option value="Fatherinlaw">Father-in-law</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Sum Insured</Form.Label>
                    <Form.Control
                      type="number"
                      name="suminsured"
                      value={addMemberForm.suminsured}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Sum Insured"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control
                      type="text"
                      name="pincode"
                      value={addMemberForm.pincode}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Pincode"
                      maxLength="6"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <Form.Control
                      type="tel"
                      name="mobilenumber"
                      value={addMemberForm.mobilenumber}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Mobile Number"
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email ID</Form.Label>
                    <Form.Control
                      type="email"
                      name="emailId"
                      value={addMemberForm.emailId}
                      onChange={this.handleAddMemberFormChange}
                      placeholder="Enter Email ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showAddMemberModal: false })}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this.addNewMember}>
              Add Member
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}